import React from 'react';
import { Sun, Moon, Github, Linkedin } from 'lucide-react';

interface NavbarProps {
  theme: 'dark' | 'light';
  onToggleTheme: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({ theme, onToggleTheme }) => {
  return (
    <header className="navbar">
      <div className="container nav-container">
        <a href="#" className="nav-brand">
          <span>Thomas Desrosiers</span>
          <span className="nav-brand-tag">Google & Classical Remix</span>
        </a>

        <nav>
          <ul className="nav-links">
            <li><a href="#work" className="nav-link">Selected Work</a></li>
            <li><a href="#recordings" className="nav-link">Performance</a></li>
            <li><a href="#credentials" className="nav-link">Background</a></li>
            <li><a href="#contact" className="nav-link">Connect</a></li>
          </ul>
        </nav>

        <div className="nav-actions">
          <a 
            href="https://github.com/tdesrosi" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="theme-toggle-btn"
            title="GitHub Profile"
            aria-label="GitHub Profile"
          >
            <Github size={18} />
          </a>
          <a 
            href="https://www.linkedin.com/in/tdesrosi/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="theme-toggle-btn"
            title="LinkedIn Profile"
            aria-label="LinkedIn Profile"
          >
            <Linkedin size={18} />
          </a>
          <button 
            onClick={onToggleTheme} 
            className="theme-toggle-btn"
            title={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
            aria-label="Toggle Theme"
          >
            {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
          </button>
        </div>
      </div>
    </header>
  );
};
